export const environment = {
    production: false,
    apiUrl: 'https://ujbjvx5oq1.execute-api.us-east-1.amazonaws.com/staging/api',
    rawAPI: 'https://ujbjvx5oq1.execute-api.us-east-1.amazonaws.com/staging',
    startup: 'https://startup-staging.stephubs.com',
    s3_bucket_basepath: 'https://stephubs-images.s3.amazonaws.com',
    landing: 'https://staging.stephubs.com'
};